import request from "../utils/request";

// 购买剧集
export function buyVideosDrama(data) {
  return request({
    url: "/Payment/buyVideosDrama",
    method: "post",
    data,
  });
}

// 获取K币消费记录
export function getGoldHistory(data) {
  return request({
    url: "/Payment/getGoldHistory",
    method: "post",
    data,
  });
}

// 获取解锁档位配置
export function getUnlockPayConfig(data) {
  return request({
    url: "/Payment/getUnlockPayConfig",
    method: "post",
    data,
    hideToastCode: "-2",
  });
}

// 获取挽留订阅档位配置（结构同 getUnlockPayConfig 返回的 subscription_config 档位；失败静默）
export function getRetentionConfig(data) {
  return request({
    url: "/Payment/getRetentionConfig",
    method: "post",
    data,
    hideToastDialg: true,
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/Payment/createOrder",
    method: "post",
    data,
    hideToastCode: "-2",
  });
}

// 检查订单状态
export function getOrderStatus(data) {
  return request({
    url: "/Payment/getOrderStatus",
    method: "post",
    data,
  });
}
